import React from "react"

type Props = {}

type State = { hasError: boolean }

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props | Readonly<Props>) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: { message: any }) {
    return { hasError: true, errorMessage: error.message }
  }

  componentDidCatch(_error: any, _errorInfo: any) {
    return { ...this.state }
  }

  render() {
    if (this.state.hasError) {
      return ""
    } else {
      return this.props.children
    }
  }
}

export default ErrorBoundary
